fragment AiUserFragment on AiUser {
    user {
        id
        name
        initials
        avatarUrl
    }
    timeSaved
    outcomeCount
}
